var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    "aria-hidden": "true",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "red",
    clipRule: "evenodd",
    d: "M11 20.167a9.167 9.167 0 1 1 0-18.334 9.167 9.167 0 0 1 0 18.334Zm0-1.834a7.333 7.333 0 1 0 0-14.666 7.333 7.333 0 0 0 0 14.666ZM15.583 11a4.583 4.583 0 1 1-9.166 0 4.583 4.583 0 0 1 9.166 0Z"
  })));
};
export default SvgStop;